<template>
  <div>
    <h2 class="tracking-status-text">
      {{ statusName }}
    </h2>
    <h4 class="text-black-50 tracking-desc">
      {{ statusDescription }}
    </h4>

    <hr class="tracking-divider" />
  </div>
</template>

<script lang="ts">
import type { TrackingEvent } from '@/types/Models/Shipment'
import { defineComponent, computed, type PropType, type ComputedRef } from 'vue'
import { useI18n } from 'vue-i18n'
import { capitalizeFirstLetter } from '@/helpers/Utils'
import { useTrackingStore } from '@/store/modules/tracking'

export default defineComponent({
  name: 'TrackingStatus',
  props: {
    event: {
      type: Object as PropType<TrackingEvent | null>,
      required: false,
      default: null,
    },
  },
  setup(props) {
    const { t, te } = useI18n()
    const trackingStore = useTrackingStore()

    // In the page language with a capital letter ("Levererad"), not the raw status ("delivered")
    const statusName: ComputedRef<string> = computed(() => {
      const status = props.event?.status
      if (!status) return t('steps.booked')
      return te(`statuses.${status}`) ? t(`statuses.${status}`) : capitalizeFirstLetter(status.replace(/_/g, ' '))
    })

    const statusDescription: ComputedRef<string> = computed(() => {
      return props.event?.status && props.event.description
        ? trackingStore.eventText(props.event.description)
        : t('haveNotReceivedShippingTime')
    })

    return {
      statusName,
      statusDescription,
    }
  },
})
</script>
